import { gql } from '@apollo/client'

const UPDATE_FOOD_MOOD_SIMPLE_DETAILS_MUTATION = gql`
  mutation updateFoodMoodSimpleDetails(
    $id: ID!
    $data: FoodMoodSimpleDetailsInput!
  ) {
    updateFoodMoodSimpleDetails(id: $id, data: $data) {
      id
      description
      updatedAt
      updatedBy {
        id
        name
      }
      position
      synonyms
      isExcludedFromSearch
      isExcludedFromBrowsing
    }
  }
`

export default UPDATE_FOOD_MOOD_SIMPLE_DETAILS_MUTATION
